import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { useCreateProfileZipMutation } from '../../../../redux/api/fymAPI';
import { isSuccessfulResult } from '../../../../redux/api/utils/isSuccessfulResult';
import { downloadMediaUrl } from '../inlineMediaUrl';
import { studioActionErrorFeedback, type StudioActionFeedback } from '../studio/studioActionErrorText';

/** Starts the download of a file address with the name that the server gives it. */
function startDownload(url: string, fileName: string): void {
  const link = document.createElement('a');
  link.href = downloadMediaUrl(url);
  link.download = fileName;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/** "Download all" (design a1): `POST .../artist-profile/zip` → "LaziiBee - Profile.zip". */
export function useProfileZip(accountId: number) {
  const intl = useIntl();
  const [createZip, { isLoading }] = useCreateProfileZipMutation();
  const [feedback, setFeedback] = useState<StudioActionFeedback | null>(null);
  const download = useCallback(() => {
    setFeedback(null);
    createZip({ accountId })
      .then((result) => {
        if (isSuccessfulResult(result)) {
          startDownload(result.data.url, result.data.fileName);
          return;
        }
        setFeedback(studioActionErrorFeedback(intl, 'profile zip', result.error));
      })
      .catch(console.error);
  }, [accountId, createZip, intl]);
  return { download, isBusy: isLoading, feedback };
}
